import type { StateCreator } from "zustand";

export interface ControlledLoginSlice {
  controlledLoginEmail: string;
  controlledLoginUserExist: boolean;
  setControlledLoginEmail: (email: string) => void;
  setControlledLoginUserExist: (exists: boolean) => void;
  resetControlledLogin: () => void;
}

export const createControlledLoginSlice: StateCreator<ControlledLoginSlice> = (set) => ({
  controlledLoginEmail: "",
  controlledLoginUserExist: false,
  setControlledLoginEmail: (email: string) => set({ controlledLoginEmail: email }),
  setControlledLoginUserExist: (exists: boolean) => set({ controlledLoginUserExist: exists }),
  resetControlledLogin: () =>
    set({ controlledLoginEmail: "", controlledLoginUserExist: false }),
});
